import { createGlobalStore } from "use-global-state-react";

export default createGlobalStore("eventNear", []);